import { render, staticRenderFns } from "./ArgumentControl.vue?vue&type=template&id=5b98cac8&scoped=true&"
import script from "./ArgumentControl.vue?vue&type=script&lang=js&"
export * from "./ArgumentControl.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b98cac8",
  null
  
)

export default component.exports